import { normalizeValue } from './ValueNormalizer';

export const TractorType = [
  '2500HD',
  '3500HD',
  'Aerial Fire Truck',
  'Boom Truck',
  'Box Truck',
  'BUS',
  'Concrete Mobile',
  'Concrete Truck',
  'Crane',
  'Dump truck',
  'F550',
  'F550XL',
  'Farm Implement',
  'Field Service Truck',
  'Fire Truck',
  'Flat Bed',
  'Heavy Haul Tractor',
  'K2500',
  'Low Sleeper',
  'LTM 1130-5.1',
  'MH Toter',
  'Mobile Unit',
  'N/A',
  'Pick Up',
  'Pumper Fire Truck',
  'Pumper/Tanker',
  'Rollback Truck',
  'Rollback Wrecker',
  'Self Propelled',
  'Semi',
  'Service Truck',
  'S/P Oil Service Rig',
  'Special mobile Equipment',
  'Stake Bed Truck',
  'Straight Truck',
  'T800',
  'Tanker Truck',
  'Toter',
  'Tow Truck',
  'Tractor',
  'Tractor 4 Axle Lift',
  'Tri Axle Roll Off Wrecker',
  'Truck',
  'Truck Tractor',
  'Van',
  'Winch Truck',
] as const;

export const normalizeTractorType = (
  type?: string | null,
): string | undefined => {
  return normalizeValue(TractorType, type);
};
